import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import EditFeatureAccess from "@/Components/common/client/useraccess/roleaccess/EditRoleAccessSteps/EditFeatureAccess";
import EditModuleAccess from "@/Components/common/client/useraccess/roleaccess/EditRoleAccessSteps/EditModuleAccess";
import EditRoleAccessSteps from "@/Components/common/client/useraccess/roleaccess/EditRoleAccessSteps/EditRoleAccessSteps";
import EditRoleBasicInfo from "@/Components/common/client/useraccess/roleaccess/EditRoleAccessSteps/EditRoleBasicInfo";
import {
  updateEditActiveStep,
  updateRoleAccessData,
} from "@/reducers/client_user/roleAccess";

import { _editClientRole } from "../../../../services/clientusers";
import useTitle from "../../../../utilities/hooks/useTitle";
import { apiDecrypt } from "../../../../utilities/keyEncryption";
import { handleAPICatch } from "../../../../utilities/utils";

const EditRoleAccess = () => {
  useTitle("Edit Role");
  const { editActiveStep, roles, jobShiftObj } = useSelector(
    (state) => state.clientRoles,
  );
  const [data, setData] = useState({});
  const { id } = useParams();

  const dispatch = useDispatch();

  const fetchEditRoleData = (id) => {
    let decryptedId = apiDecrypt(id);
    let response = _editClientRole({ role_id: decryptedId });
    response
      .then((res) => {
        const {
          data: { user_role_detail },
        } = res;
        let allPermission = user_role_detail.allPermission;
        Object.keys(allPermission)
          .filter((key) => allPermission[key] === 1)
          .map((key) => {
            allPermission[key] = true;
          });
        setData({ ...user_role_detail, allPermission });
      })
      .catch((error) => {
        handleAPICatch(error);
      });
  };

  useEffect(() => {
    fetchEditRoleData(id);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(data)) {
      dispatch(updateEditActiveStep(1));
      dispatch(
        updateRoleAccessData({
          roleName: data?.role_name,
          roleDescription: data?.role_description,
          allPermission: data?.allPermission ? data.allPermission : {},
          roleId: data.role_id,
        }),
      );
    }
  }, [data]);

  return (
    <>
      <EditRoleAccessSteps />
      {editActiveStep === 1 ? <EditRoleBasicInfo /> : null}
      {editActiveStep === 2 ? <EditModuleAccess /> : null}
      {editActiveStep === 3 ? <EditFeatureAccess /> : null}
    </>
  );
};

export default EditRoleAccess;
